"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tapBoth = exports.tapErr = exports.tapOk = void 0;
var inspect_1 = require("./inspect");
/**
 *  @deprecated
 *  This will be removed in a future release.
 *  Use {@link inspectOkOfResult}
 */
exports.tapOk = inspect_1.inspectOkOfResult;
/**
 *  @deprecated
 *  This will be removed in a future release.
 *  Use {@link inspectErrOfResult}
 */
exports.tapErr = inspect_1.inspectErrOfResult;
/**
 *  @deprecated
 *  This will be removed in a future release.
 *  Use {@link inspectBothOfResult}
 */
exports.tapBoth = inspect_1.inspectBothOfResult;
